import React, { useState, useEffect } from "react";
import { ShoppingBag } from "lucide-react";
import { ARTIST } from "../data/worldData";

const LINKS = [
  { id: "home", label: "HOME" },
  { id: "gallery", label: "GALLERY" },
  { id: "music", label: "MUSIC" },
  { id: "shop", label: "SHOP" },
];

export default function TopNav({ scrollRef, cartCount = 0, onCart }) {
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const el = scrollRef?.current;
    if (!el) return;
    const onScroll = () => setSolid(el.scrollLeft > 40);
    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [scrollRef]);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });

  return (
    <header className={`fixed top-0 inset-x-0 z-[60] transition-colors duration-300 ${solid ? "bg-[#15100E] text-[#ECE7DB]" : "bg-transparent text-[#15100E]"}`}>
      <div className="flex items-center justify-between px-4 sm:px-6 h-14 border-b-2 border-[#15100E]" style={{ borderColor: solid ? "#ECE7DB" : "#15100E" }}>
        <button data-testid="nav-home" onClick={() => go("home")} className="font-display font-extrabold tracking-tight text-lg sm:text-xl">
          {ARTIST}
        </button>
        <nav className="flex items-center gap-1 sm:gap-2">
          {LINKS.slice(1).map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-tech text-[11px] sm:text-xs tracking-[0.15em] px-2 sm:px-4 py-2 hover:text-[#CF9026] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button data-testid="nav-cart" onClick={onCart} className="relative ml-1 h-9 w-9 flex items-center justify-center hover:text-[#CF9026] transition-colors">
            <ShoppingBag size={18} />
            {cartCount > 0 && (
              <span data-testid="cart-count" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#CF9026] text-[#15100E] font-tech text-[10px] flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </button>
        </nav>
      </div>
    </header>
  );
}
